import React from 'react';

export const Fireflies = () => {
  const positions = [
    { top: '20%', left: '10%' },
    { top: '35%', right: '15%' },
    { top: '55%', left: '25%' },
    { top: '15%', right: '30%' },
    { top: '70%', left: '60%' },
    { top: '45%', right: '8%' },
    { top: '25%', left: '45%' },
    { top: '60%', right: '40%' },
  ];

  return (
    <>
      {positions.map((pos, i) => (
        <div
          key={i}
          className="firefly"
          style={{
            ...pos,
            animationDelay: `${i * 0.7}s`,
            animationDuration: `${3.5 + (i % 3)}s`,
          }}
        />
      ))}
    </>
  );
};

export default Fireflies;
